var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7106 2.96981C42.5348 2.78596 42.2822 2.68188 42.0185 2.68188H5.39381C5.13016 2.68188 4.8775 2.78596 4.70174 2.96981C4.52231 3.15367 4.43443 3.39997 4.46006 3.64974L7.75929 38.6625C7.79225 39.0302 8.06321 39.3355 8.43671 39.4396L23.4462 43.4983C23.5267 43.5226 23.6146 43.533 23.7025 43.533C23.7904 43.533 23.8746 43.5226 23.9588 43.4983L38.9793 39.4396C39.3528 39.3355 39.6201 39.0302 39.6567 38.6625L42.9523 3.64974C42.9779 3.39997 42.89 3.15367 42.7106 2.96981ZM34.8122 15.042H17.1773L17.5984 19.5621H34.3875L33.1278 32.9213L23.6988 35.6202L23.6073 35.5925L14.2882 32.9178L13.7792 27.4749H18.3454L18.5431 29.5876L23.7538 30.6213L28.8692 29.5876L29.4148 23.8706H13.4386L12.1973 10.7231H35.2187L34.8122 15.042Z",
    fill: "#4B4E59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.5ecbdcd4c2aa3eb31e4968a0bdcc9c7d.svg";
export { ForwardRef as ReactComponent };